/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_DISPLAY_COOLER_PRODUCT_HOVER_STATS = gql`
  query DisplayCoolerProductHoverStats(
    $displayId: ID!
    $upc: String!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    displayCoolerProductHoverStats(
      displayId: $displayId
      upc: $upc
      startDate: $startDate
      endDate: $endDate
    ) {
      upc
      name
      revenue
      revenueTrend
      averageVolumePerDay
      revenueSeries {
        date
        revenue
      }
    }
  }
`
